import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SERVICE_CONFIG, TaskService} from "../../services/task.service";
import {DomSanitizer} from "@angular/platform-browser";
import {PlatformLocation} from "@angular/common";

@Component({
  selector: 'nf-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {

  uploadFileUrl;
  downloadFileUrl;
  pdfPreviewPrefix;
  wordPreviewPrefix;
  watermarkFileUrl;
  pdfPreviewUrl;
  wordPreviewUrl;
  pdfJsUrl = 'assets/pdfjs-dist/web/viewer.html?file=';
  boardId;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardId = data.id;
      this.boardColumnData = data.boardData.columns ? data.boardData.columns : [];
    }
  };
  @Input('boardColumn') set boardColumnChange(data) {
    if (data) {
      this.boardColumnData = data;
    }
  }
  boardColumnData = [];
  pulse: any = {};
  @Input('pulse') set pulseChange(data) {
    if (data) {
      this.pulse = data;
      if (this.boardColumnData) {
        for (let column of this.boardColumnData) {
          if (column.type == 'name') {
            this.taskName = this.pulse.columnValues[column.id];
            break;
          }
        }
      }
    }
  };
  taskName = '';
  @Input() columnValue = {
    config: {
      watermark: true,
      watermarkContent: ''
    },
    files: []
  };
  @Input() disabled = false;
  @Input() column: any = {};
  addFilePop = false;
  selectedFile = {
    id: '',
    name: '',
    type: '',
    created: 0,
    size: 0,
    taskName: ""
  };
  selectIndex = -1;
  configPopVisible = false;
  modalVisible = false;
  modalWidth;
  modalHeight;
  imageHeight;
  @Output() updateFilterData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private sanitizer: DomSanitizer,
    private location: PlatformLocation
  ) { }

  ngOnInit(): void {
    const prefix = this.taskService.getPrefix();
    const viewPrefix = this.location.protocol + '//' + this.location.hostname + prefix;
    this.uploadFileUrl = prefix + '/v1/files/upload';
    this.downloadFileUrl = prefix + '/v1/files/downloads/';
    this.pdfPreviewPrefix = viewPrefix + '/v1/files/pdf_preview/';
    this.wordPreviewPrefix = viewPrefix + '/v1/files/word_preview/';
    this.watermarkFileUrl = prefix + '/v1/files/downloads/watermark/';
    this.modalWidth = window.innerWidth * 0.9;
    this.modalHeight = window.innerHeight * 0.85 + 'px';
    this.imageHeight = window.innerHeight * 0.85 - 64 + 'px';
    if (!this.columnValue) {
      this.columnValue = {
        config: {
          watermark: true,
          watermarkContent: ''
        },
        files: []
      };
    }
    if (!this.columnValue.files) {
      this.columnValue.files = [];
    }
    if (!this.columnValue.config) {
      this.columnValue.config = {
        watermark: true,
        watermarkContent: ''
      };
    }
  }

  getFileIcon(type):string {
    let icon = '';
    switch (type) {
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        icon = 'word.svg';
        break;
      case 'application/msword':
        icon = 'word.svg';
        break;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        icon = 'excel.svg';
        break;
      case 'application/vnd.ms-excel':
        icon = 'excel.svg';
        break;
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        icon = 'ppt.svg';
        break;
      case 'application/vnd.ms-powerpoint':
        icon = 'ppt.svg';
        break;
      case 'text/html':
        icon = 'html.png';
        break;
      case 'image/jpeg':
        icon = 'jpg.png';
        break;
      case 'image/png':
        icon = 'png.png';
        break;
      case 'audio/mp3':
        icon = 'mp3.png';
        break;
      case 'video/mp4':
        icon = 'mp4.png';
        break;
      case 'application/pdf':
        icon = 'pdf.svg';
        break;
      case 'text/plain':
        icon = 'txt.png';
        break;
      case 'text/xml':
        icon = 'xml.png';
        break;
      default:
        icon = 'unknown.svg';
        break;
    }
    return icon;
  }

  openFileDialog() {
    document.getElementById('uploadFile').click();
  }

  // 处理上传
  uploadFile(event) {
    if (event && event.type === 'success') {
      if (event.file && event.file.response) {
        this.addFile(event.file.response);
      }
    }
  }

  addFile(file) {
    const item = {
      id: file.id,
      name: file.name,
      type: file.contentType,
      created: file.createdAt,
      size: file.fileSize,
      taskName: this.taskName
    };
    if (!this.columnValue.files) {
      this.columnValue.files = [];
    }
    this.columnValue.files.push(item);
    this.saveValue();
  }

  deleteFile(i) {
    this.columnValue.files.splice(i, 1);
    this.saveValue();
  }

  saveValue() {
    const param = {};
    param['pulseIds'] = [this.pulse.id];
    param['columnId'] = this.column.id;
    param['columnValue'] = this.columnValue;
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.configPopVisible = false;
      this.updateFilterData.emit();
    });
  }

  openViewDialog(file, i) {
    this.selectedFile = file;
    this.getFilePreviewUrl(file);
    this.selectIndex = i;
    this.addFilePop = false;
    this.modalVisible = true;
  }

  getFileSuffix(name: string) {
    if (name) {
      return name.substring(name.lastIndexOf('.') + 1, name.length);
    }
    return '未知类型'
  }

  translateSize(size: number) {
    let scale = 0;
    while (size > 1024) {
      size = size / 1024;
      scale++;
    }
    let unit = 'b';
    if (scale == 1) {
      unit = 'kb';
    } else if (scale == 2) {
      unit = 'Mb';
    } else if (scale == 3) {
      unit = 'Gb';
    }
    if (!size) {
      size = 0;
    }
    return size.toString().substring(0, 3) + unit;
  }

  preFile() {
    if (this.selectIndex == 0) {
      this.selectIndex = this.columnValue.files.length - 1;
    } else {
      this.selectIndex -= 1;
    }
    this.selectedFile = this.columnValue.files[this.selectIndex];
    this.getFilePreviewUrl(this.selectedFile);
  }

  nextFile() {
    if (this.selectIndex == (this.columnValue.files.length - 1)) {
      this.selectIndex = 0;
    } else {
      this.selectIndex += 1;
    }
    this.selectedFile = this.columnValue.files[this.selectIndex];
    this.getFilePreviewUrl(this.selectedFile);
  }

  getFilePreviewUrl(file) {
    console.log(file);
    let watermark = this.columnValue.config && this.columnValue.config.watermark ?
      (this.columnValue.config.watermarkContent?this.columnValue.config.watermarkContent:''): '';
    let url = '';
    if (file.type == 'application/pdf') {
      url = this.pdfPreviewPrefix + file.id + '?watermark=' + watermark + '';
      this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfJsUrl + encodeURIComponent(url));
    } else if (file.type == 'application/msword' || file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      url = this.wordPreviewPrefix + file.id + '?watermark=' + watermark + '';
      this.wordPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfJsUrl + encodeURIComponent(url));
    }
    console.log(url);
  }

  downloadAll() {
    if (this.columnValue.files) {
      const ids = [];
      for (let file of this.columnValue.files) {
        ids.push(file.id);
      }
      if (ids.length > 0) {
        if (this.columnValue.config && this.columnValue.config.watermark) {
          const params = {
            idList: ids,
            watermark: this.columnValue.config.watermarkContent
          };
          this.taskService.batchDownloadWithWatermark(params).subscribe(res => {
            this.handleRes(res);
          });
        } else {
          this.taskService.batchDownload(ids).subscribe((result: any) => {
            this.handleRes(result);
          });
        }
      }
    }
  }

  handleRes(result) {
    const link = document.createElement('a');
    const blob = new Blob([result], {type: 'application/octet-stream'});
    link.setAttribute('target', '_blank');
    link.setAttribute('href', window.URL.createObjectURL(blob));
    link.setAttribute('download', '文件包.zip');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
